//-------------------------------------------------------------------------------------------------- Imports
import { PayloadAction, createSlice } from "@reduxjs/toolkit";


//-------------------------------------------------------------------------------------------------- Interfaces
interface InfoCardSliceInterface {
    show: boolean;
    title: string;
    description: string;
    color?: string;
    colorText?: string;
};



//-------------------------------------------------------------------------------------------------- Vars and consts
const infoCardSliceInitialState = {
    show: false,
    title: "",
    description: "",
    color: "",
    colorText: ""
} as InfoCardSliceInterface;



//-------------------------------------------------------------------------------------------------- Slice
const infoCardSlice = createSlice({
    name: "infoCard",
    initialState: infoCardSliceInitialState,
    reducers: {
        setInfoCard: (state, action: PayloadAction<InfoCardSliceInterface>) => {
            state.show = action.payload.show;
            state.title = action.payload.title;
            state.description = action.payload.description;
            state.color = action.payload.color;
            state.colorText = action.payload.colorText;
           
        },
        showInfoCard: (state, action: PayloadAction<boolean>) => {
            state.show = action.payload;
        },
        clearInfoCard: (state) => {
            state.show = infoCardSliceInitialState.show;
            state.title = infoCardSliceInitialState.title;
            state.description = infoCardSliceInitialState.description;
            state.color = infoCardSliceInitialState.color;
            state.colorText = infoCardSliceInitialState.colorText;

        }
    }
});



//-------------------------------------------------------------------------------------------------- Exports
export const { setInfoCard, showInfoCard, clearInfoCard } = infoCardSlice.actions;
export const getInfoCardData = (state: any) => (state.infoCard) as InfoCardSliceInterface;
export default infoCardSlice.reducer;
